import { Divider, Menu } from 'antd'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BadgeMessage } from 'components/ui/badgeMessage/badgeMessage'
import { IMenuItem } from '../useMenuItems'
import styles from './Menu.module.scss'
import { Title } from './styled'

interface IMenuItemProps {
  index: number
  item: IMenuItem
  siderIsCollapsed: boolean
  totalItems: number
}

const MenuItem: React.FC<IMenuItemProps> = ({
  index,
  item,
  siderIsCollapsed: collapsed,
  totalItems,
  ...rest
}) => {
  const badgeChat = () => {
    if (
      item.badgeValue !== undefined &&
      item.badgeValue > 0 &&
      item.badgeValue <= 9
    ) {
      return `${item.badgeValue}`
    }

    // El 9+ se utiliza por la convención de las notificaciones del hub de rankmi
    if (item.badgeValue !== undefined && item.badgeValue > 9) {
      return '9+'
    }
  }

  return item.icon && item.url ? (
    <Menu.Item
      {...rest}
      className={`${styles.menuItem} ${
        collapsed ? styles.menuItemCollapsed : ''
      }`}
    >
      <span
        className={`${collapsed ? styles.badgeNumber : ''}`}
        data-count={badgeChat()}
      >
        <FontAwesomeIcon
          className={`${styles.menuItemIcon} ${
            collapsed ? styles.menuItemIconCollapsed : ''
          }`}
          icon={item.icon}
        />
      </span>
      <span
        className={`${styles.menuItemSpan} ${
          collapsed ? styles.menuItemSpanCollapsed : ''
        }`}
      >
        {item.text}
      </span>
      {item.badgeValue !== undefined && !collapsed && item.badgeValue > 0 && (
        <BadgeMessage number={badgeChat()} />
      )}
    </Menu.Item>
  ) : totalItems > index + 1 ? (
    <Title>
      {index > 0 && <Divider />}
      {!collapsed && <div>{item.text}</div>}
    </Title>
  ) : (
    <></>
  )
}

export default MenuItem
